import React from "react";

export default function LoadingState() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#1d57a5]/20 border-t-[#1d57a5] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-500">Loading mappings...</p>
      </div>
    </div>
  );
}